import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-eq-printer",
  "use": "icon-eq-printer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eq-printer\"><path d=\"M768 64c38.4 0 64 25.6 64 64v64h64c38.4 0 64 25.6 64 64v448c0 38.4-25.6 64-64 64h-64v128c0 38.4-25.6 64-64 64H256c-38.4 0-64-25.6-64-64v-128H128c-38.4 0-64-25.6-64-64V256c0-38.4 25.6-64 64-64h64V128c0-38.4 25.6-64 64-64h512z m0 512H256v320h512V576z m128-320H128v448h64V576c0-38.4 25.6-64 64-64h512c38.4 0 64 25.6 64 64v128h64V256z m-64 64v64h-64V320h64z m-64-192H256v64h512V128z\" p-id=\"4397\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/eq-printer.svg
// module id = eUJG
// module chunks = 67